module.exports = __webpack_public_path__ + "static/media/ddos.90f0f7ee.png";